module.exports = __webpack_public_path__ + "img/22a)Hotel Fürstenhof.jpg";